module.exports = __webpack_public_path__ + "static/3-04559cddf5052651c9ea302998457472.jpg";